import { render, staticRenderFns } from "./accessdenied.vue?vue&type=template&id=ce9c5502&scoped=true&"
import script from "./accessdenied.vue?vue&type=script&lang=js&"
export * from "./accessdenied.vue?vue&type=script&lang=js&"
import style0 from "./accessdenied.vue?vue&type=style&index=0&id=ce9c5502&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce9c5502",
  null
  
)

export default component.exports